import { PageModuleDataToUpdate } from "entities/pages/types";
import { doc, writeBatch } from "firebase/firestore";
import { db } from "shared/api/firebase";

type Data = {
  [moduleId: string]: PageModuleDataToUpdate;
};

export const bulkUpdateModulesByBrandSetting = async (
  brandId: string,
  settingId: string,
  data: Data,
): Promise<void> => {
  const batch = writeBatch(db);

  Object.entries(data).forEach(([moduleId, moduleData]) => {
    const docRef = doc(
      db,
      `brands/${brandId}/settings/${settingId}/modules/${moduleId}`,
    );
    batch.update(docRef, moduleData);
  });

  await batch.commit();
};
